import { Typography, styled } from "@mui/material";
import pxToRem from "theme/base/pxToRem";

export const FileNumber = styled(Typography)(({ theme }) => ({
  lineHeight: theme.typography.lineHeight.md,
  fontSize: theme.typography.size.sm_14,
  fontWeight: theme.typography.fw_regular_400,
  color: theme.palette.text.textPrimary,
}));

export const PreviewFileWrapper = styled("div")<{ error?: boolean }>(
  ({ error }) => ({
    width: pxToRem(100),
    position: "relative",
    border: `1px solid ${error ? "red" : "transparent"}`,
    boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.10)",
    borderRadius: pxToRem(4),
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",

    "&:hover .close": {
      opacity: 1,
      visibility: "visible",
    },
  })
);

export const CloseButton = styled("div")(() => ({
  opacity: 0,
  visibility: "hidden",
  transition: "opacity 0.3s ease, visibility 0.2s ease",
  width: pxToRem(16),
  height: pxToRem(16),
  position: "absolute",
  top: pxToRem(6),
  right: pxToRem(6),
  borderRadius: "50%",
  backgroundColor: "#FFF",
  cursor: "pointer",
}));

export const PreviewImage = styled("img")(() => ({
  height: pxToRem(48),
  width: "100%",
  objectFit: "cover",
}));

export const PreviewFile = styled("div")(() => ({
  height: pxToRem(48),
  width: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  svg: { width: pxToRem(22) },
}));

export const FileName = styled(Typography)(({ theme }) => ({
  padding: `${pxToRem(4)} ${pxToRem(8)}`,
  overflow: "ellipsis",
  whiteSpace: "nowrap",
  lineHeight: theme.typography.lineHeight.md,
  fontSize: theme.typography.size.sm_14,
  fontWeight: theme.typography.fw_regular_400,
  color: theme.palette.text.textPrimary,
}));

export const UploadMoreWrapper = styled("div")(({ theme }) => ({
  width: pxToRem(100),
  height: pxToRem(76),
  boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.10)",
  borderRadius: pxToRem(8),
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  border: `1px dashed ${theme.palette.stroke.strokeBrand}`,
  cursor: "pointer",
  transition: "all 0.3s ease, visibility 0.2s ease",

  ":hover": {
    backgroundColor: theme.palette.background.bgTertiary,
  },
}));
